/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionResultModel } from '../../models/session-result-model';

export interface SessionHistorySystemIdentifierIdGet$Params {
  systemIdentifierId: string;
  pageNumber?: number;
  fromDate?: string;
  toDate?: string;
}

export function sessionHistorySystemIdentifierIdGet(http: HttpClient, rootUrl: string, params: SessionHistorySystemIdentifierIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<SessionResultModel>>> {
  const rb = new RequestBuilder(rootUrl, sessionHistorySystemIdentifierIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<SessionResultModel>>;
    })
  );
}

sessionHistorySystemIdentifierIdGet.PATH = '/Session/History/{systemIdentifierId}';
